import type { accountMenu as en } from '@/i18n/locales/en/accountMenu';
import type { Translation } from '@/i18n/types';

export const accountMenu: Translation<typeof en> = {
  trigger: 'Hesap',
  viewProfile: 'Profili görüntüle',
  roles: {
    admin: 'Platform yöneticisi',
    companyAdmin: 'Şirket yöneticisi',
    departmentAdmin: 'Departman yöneticisi/koçu',
  },
  company: {
    label: 'Şirket',
    switchTo: '{{name}} hesabına geç',
  },
  accounts: {
    label: 'Diğer hesaplar',
    switchTo: '{{name}} hesabına geç',
    addAnother: 'Başka bir hesapla oturum aç',
  },
  manage: 'Yönet',
  settings: 'Şirket profili',
  language: 'Dil',
  theme: {
    label: 'Tema',
    light: 'Açık',
    dark: 'Koyu',
    system: 'Sistem',
  },
  signOut: 'Oturumu kapat',
  signOutAll: 'Tüm hesaplarda oturumu kapat',
};
